// Constants
const ARIA_EXPANDED = 'aria-expanded';
const EVENT_KEYDOWN = 'keydown';
const EVENT_CLICK = 'click';

const initProductConsultationModal = () => {
  const triggers = document.querySelectorAll('a[href="#open-consultation-modal"]');
  const modal = document.querySelector('[data-consultation-modal-popup]');
  const overlay = document.querySelector('[data-consultation-modal-overlay]');
  const closeBtn = modal?.querySelector('[data-consultation-modal-close]');
  if (!triggers.length || !modal || !closeBtn || !overlay) return;

  let handleEscape;

  /* eslint-disable no-use-before-define */
  const close = () => {
    modal.classList.add('translate-x-full');
    modal.setAttribute(ARIA_EXPANDED, 'false');
    overlay.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener(EVENT_KEYDOWN, handleEscape);
    closeBtn.removeEventListener(EVENT_CLICK, close);
    overlay.removeEventListener(EVENT_CLICK, close);
    document.removeEventListener(EVENT_CLICK, handleClickOutside);
  };

  const handleClickOutside = (e) => {
    const isInsideModal = modal.contains(e.target);
    const isTrigger = Array.from(triggers).some(trigger => trigger.contains(e.target));
    if (!isInsideModal && !isTrigger && modal.getAttribute(ARIA_EXPANDED) === 'true') {
      close();
    }
  };

  const open = () => {
    handleEscape = (e) => {
      if (e.key === 'Escape') close();
    };
    modal.classList.remove('translate-x-full');
    modal.setAttribute(ARIA_EXPANDED, 'true');
    overlay.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    document.addEventListener(EVENT_KEYDOWN, handleEscape);
    closeBtn.addEventListener(EVENT_CLICK, close);
    overlay.addEventListener(EVENT_CLICK, close);
    document.addEventListener(EVENT_CLICK, handleClickOutside);
  };
  /* eslint-enable no-use-before-define */

  triggers.forEach(trigger => {
    trigger.addEventListener(EVENT_CLICK, (e) => {
      e.preventDefault();
      open();
    });
  });
};

export default initProductConsultationModal;
